<!-- =========================================================================================
    File Name: Invoice.vue
    Description: Invoice Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="invoice-page">
        <vx-card title="Cargar documentos" code-toggler>



            <div class="demo-alignment">

                <vs-list>
                    <vs-list-header title="Escanear y cargar en PDF por separado cada uno de los siguientes documentos y asignarles el nombre que corresponda, ejemplo: Acta de nacimiento.PDF"></vs-list-header>

                    <vs-list-item title="1.SOLICITUD DE INSCRIPCIÓN DEBIDAMENTE CONTESTADA Y CON FOTOGRAFÍAS TAMAÑO INFANTIL, RECIENTES (NO OLVIDES ANEXAR COPIA DE TU INE/IFE  Y DE TUS PAPÁS)" subtitle=""></vs-list-item>
                    <vs-list-item title="2.ACTA DE NACIMIENTO (AÑO 2020) EN ORIGINAL" subtitle=""></vs-list-item>
                    <vs-list-item title="3.CERTIFICADO DE BACHILLERATO DEBIDAMENTE LEGALIZADO EN CASO DE SER NECESARIO. (TAMAÑO CARTA) O CONSTANCIA DE TERMINACIÓN DE ESTUDIOS (INDICANDO QUE TU CERTIFICADO SE ENCUENTRA EN TRÁMITE)" subtitle=""></vs-list-item>
                    <vs-list-item title="4.EXAMEN MÉDICO GENERAL QUE CONTENGA EL GRUPO SANGUÍNEO DE INSTITUCIÓN PUBLICA (IMSS, CRUZ ROJA, ISSSTE.)" subtitle=""></vs-list-item>
                    <vs-list-item title="5.CARTA DE BUENA CONDUCTA." subtitle=""></vs-list-item>
                    <vs-list-item title="6.COPIA DE COMPROBANTE DE DOMICILIO NO MAYOR A 3 MESES DE EXPEDICIÓN." subtitle=""></vs-list-item>
                    <vs-list-item title="7.CURP DESCARGADA DE RENAPO." subtitle=""></vs-list-item>
                    <vs-list-item title="8.COMPROBANTE DE FOLIO SUREDSU EN CASO DE NO TENERLO FAVOR DE SOLICITARLO EN http://suredsu.guanajuato.gob.mx" subtitle=""></vs-list-item>

                </vs-list>
<p>
    Una vez cargados los documentos, deberás esperar alrededor de 1 hora mientras se realiza la validación de los mismos por el personal de control escolar. Si cumplen con todas las especificaciones se te hará llegar la referencia de pago. (Por ningún motivo realizar pago con alguna otra referencia no proporcionada por control escolar, de lo contrario el pago no será válido).
<br/>
    Una vez realizado el pago, escanear el comprobante en formato PDF y acceder nuevamente al sistema para cargarlo. Para finalizar el proceso recibirás comprobante de inscripción, horario de clases virtuales y comprobante de documentos cargados.
</p>
            </div>

            <template slot="codeContainer">
                &lt;vs-list&gt;
                &lt;vs-list-header title=&quot;Group 1&quot;&gt;&lt;/vs-list-header&gt;

                &lt;vs-list-item title=&quot;Snickerdoodle&quot; subtitle=&quot;An excellent companion&quot;&gt;&lt;/vs-list-item&gt;
                &lt;vs-list-item title=&quot;Sapporo Haru&quot; subtitle=&quot;An excellent polish restaurant, quick delivery and hearty, filling meals&quot;&gt;&lt;/vs-list-item&gt;
                &lt;vs-list-header title=&quot;Group 2&quot; color=&quot;success&quot;&gt;&lt;/vs-list-header&gt;
                &lt;vs-list-item title=&quot;Enid&apos;s&quot; subtitle=&quot;At night a bar, during the day a delicious brunch spot.&quot;&gt;&lt;/vs-list-item&gt;
                &lt;vs-list-item title=&quot;Veronika Ossi&quot; subtitle=&quot;Has not watched anything recently&quot;&gt;&lt;/vs-list-item&gt;
                &lt;/vs-list&gt;
            </template>

        </vx-card>
        <vx-card title="Cargar Documentos" code-toggler>

            <p>Elige tantos archivos sean necesarios, se cargaran automaticamente al elegirlos:</p>

            <div class="mt-5">
                <!-- <vs-upload automatic id="file" name="file" :action=post_url() @on-success="successUpload" /> -->
                
                <!-- <vs-upload  id="file" name="file" />                       
                 -->




                <!-- <vs-upload  id="file" name="file"  :action=post_url() limit="1"/>    @change="getImage"    
                   action="https://cdn.upbicentenario.edu.mx/api/upload_img_perfil_admin/2"
                    :headers="{'Content-Type': 'multipart/form-data'}" 

                 -->
                   <!-- <vs-upload action="https://jsonplaceholder.typicode.com/posts/" @on-success="successUpload" /> -->
       <!-- IMG -->
        <!-- <vs-upload text="Upload Image" class="img-upload" ref="fileUpload" /> -->


        <!-- <vs-upload multiple text="Attachments" :show-upload-button="false" /> -->

        <!-- <vs-upload automatic action="https://jsonplaceholder.typicode.com/posts/" @on-success="successUpload" />        -->

        <!-- <vs-upload text="Subir Imagen"  action="" @on-success="successUpload" /> -->



   <!-- IMG -->
        <vs-upload text="Upload Image" class="img-upload" ref="fileUpload" />

             <vs-upload multiple text="Attachments" :show-upload-button="false" />

   <div class="mt-5">
            <vs-upload automatic action="https://jsonplaceholder.typicode.com/posts/" @on-success="successUpload" />
        </div>
        
 <vs-upload action="https://jsonplaceholder.typicode.com/posts/" @on-success="successUpload" />


            </div>
        </vx-card>

    </div>
</template>


<script>

export default{
    data() {
        return {
            matricula: localStorage.getItem('cuenta'),
            url: "https://saeapi.upbicentenario.edu.mx/api/upload/" + localStorage.getItem('cuenta'),
            alumno_detalle: []
        }
    },
    computed: {
           isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar');
          this.initValues();
        }
      }
    }

    },
    created() {
        this.getAlumno();


    },
    methods: {
        post_url(){
            return "https://sae.upbicentenario.edu.mx/upload/index.php?id=" + this.matricula;
        },
          successUpload() {
            this.$vs.notify({ color: 'success', title: 'Upload Success', text: 'Lorem ipsum dolor sit amet, consectetur' })
        },
        getAlumno() {
            this.$http.get("alumno_id/" + this.matricula).then(
                response => {
                    // console.log(response.data)
                    this.alumno_detalle = response.data.alumno;
                    console.log(this.alumno_detalle);

                },
                error => {
                    this.StepError(error);
                }
            );
        },
    initValues() {
      this.name = '';
      this.category = 'audio';
      this.order_status = 'pending';
      this.price = '';
      this.$refs.fileUpload.srcs = [];
    }



    },
      
  

    components: {}
}
</script>


<style lang="scss" scoped>
.add-new-data-sidebar {
  /deep/ .vs-sidebar--background {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
}
</style>

